interface StarRatingProps {
  rating: number;
  size?: "sm" | "md" | "lg";
  showValue?: boolean;
}

const sizeMap = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-base",
};

export default function StarRating({
  rating,
  size = "sm",
  showValue = false,
}: StarRatingProps) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.5;

  return (
    <span className={`inline-flex items-center gap-1 ${sizeMap[size]}`}>
      <span className="inline-flex items-center text-accent-500">
        {Array.from({ length: 5 }).map((_, index) => {
          if (index < full) return <i key={index} className="ri-star-fill" />;
          if (index === full && hasHalf) return <i key={index} className="ri-star-half-fill" />;
          return <i key={index} className="ri-star-line text-secondary-700" />;
        })}
      </span>
      {showValue && (
        <span className="text-foreground-800 font-medium ml-1">{rating.toFixed(1)}</span>
      )}
    </span>
  );
}